import './FAQ.css';
import { useState } from 'react';

function FAQ() {
  const [openIndex, setOpenIndex] = useState(null);

  const faqs = [
    {
      question: 'How often should I have my roof inspected?',
      answer: 'It is recommended to have your roof inspected at least once a year, preferably in the spring or fall. Additionally, after severe weather events like storms or heavy snowfall, an inspection is advisable.'
    },
    {
      question: 'What are the signs of a leaking roof?',
      answer: 'Signs include water stains on ceilings or walls, damp spots in the attic, mold or mildew growth, and increased energy bills. If you notice any of these, contact a professional immediately.'
    },
    {
      question: 'How long does a typical roof last?',
      answer: 'The lifespan of a roof depends on the material: asphalt shingles last 15-30 years, metal roofs 40-70 years, and tile roofs 50+ years. Regular maintenance can extend the life of your roof.'
    },
    {
      question: 'What is the difference between roof repair and replacement?',
      answer: 'Roof repair involves fixing specific damaged areas, while replacement means removing the old roof and installing a new one. Repairs are cost-effective for minor issues, but extensive damage often requires replacement.'
    },
    {
      question: 'Do I need a permit for roof work?',
      answer: 'In most areas, yes. Permits ensure the work meets local building codes. RoofPro Experts LLC handles all permitting for you, so you don\'t have to worry about it.'
    },
    {
      question: 'What materials do you use for roofing?',
      answer: 'We use high-quality materials including asphalt shingles, metal, tile, and flat roofing systems. We recommend the best option based on your home\'s needs, budget, and local climate.'
    },
    {
      question: 'How much does a new roof cost?',
      answer: 'Costs vary based on size, material, and complexity. A typical residential roof replacement ranges from $5,000 to $15,000. We provide free estimates to give you an accurate quote.'
    },
    {
      question: 'Can you work on commercial roofs?',
      answer: 'Yes, we specialize in both residential and commercial roofing services. Our team has experience with large-scale projects and can handle the unique challenges of commercial properties.'
    },
    {
      question: 'What is roof maintenance?',
      answer: 'Roof maintenance includes cleaning gutters, removing debris, checking for damage, and applying protective coatings. Regular maintenance prevents costly repairs and extends roof life.'
    },
  ];

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const firstHalf = faqs.slice(0, 5);
  const secondHalf = faqs.slice(5);

  return (
    <div className="faq-section">
      <div className="container">
        <h2>Frequently Asked Questions</h2>
        <div className="faq-columns">
          <div className="faq-list">
            {firstHalf.map((faq, index) => (
              <div key={index} className="faq-item">
                <button className="faq-question" onClick={() => toggleFAQ(index)}>
                  {faq.question}
                  <span className={`faq-icon ${openIndex === index ? 'open' : ''}`}>+</span>
                </button>
                {openIndex === index && (
                  <div className="faq-answer">
                    <p>{faq.answer}</p>
                  </div>
                )}
              </div>
            ))}
          </div>
          <div className="faq-list">
            {secondHalf.map((faq, index) => (
              <div key={index + 5} className="faq-item">
                <button className="faq-question" onClick={() => toggleFAQ(index + 5)}>
                  {faq.question}
                  <span className={`faq-icon ${openIndex === index + 5 ? 'open' : ''}`}>+</span>
                </button>
                {openIndex === index + 5 && (
                  <div className="faq-answer">
                    <p>{faq.answer}</p>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default FAQ;
